<template>
    <div :style="inlineStyles" @click="handleClick" class="centeredElement" :class="{'clickable': element.action}" v-if="! hide">
        <span v-html="element.html" class="chrome-scale-fix" style="text-align: center"></span>
    </div>
</template>
<script>
    import handleAction from "@mixins/HandleAction";

    export default {
        name:'Button',
        props:{
            element:{
                required: true,
                type: Object
            },
        },
        mixins:[
            handleAction
        ],
        data(){
            return {
                // Sometimes we may want to hide an element after it's clicked (Like with the skip to time action)
                hide: false
            }
        },

        mounted(){
            //console.log(this.element);
        },

        computed:{
            inlineStyles(){
                return {
                    background: this.element.background,
                    borderRadius: this.element.borderRadius + 'px',
                    letterSpacing: this.element.letterSpacing + 'px'
                }
            }
        },
    }
</script>
<style>
    p {
        margin: 0;
    }
</style>
<style scoped>
    div {
        position: relative;
        overflow: hidden;
    }
    .clickable:hover:before {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        content: '';
        background: rgba(0, 0, 0, 0.1);
    }
</style>